import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { Toaster } from 'sonner';
import { useState } from 'react';
import { AuthProvider } from './hooks/useAuth';
import { UserPermissionsProvider } from './contexts/UserPermissionsContext';
import { SessionRecordingProvider } from './contexts/SessionRecordingContext';
import { useOrgDefaultTheme } from './hooks/useOrgDefaultTheme';

function OrgThemeSync({ children }: { children: React.ReactNode }) {
  useOrgDefaultTheme();
  return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes (aligned with admin app)
        gcTime: 10 * 60 * 1000, // 10 minutes garbage collection
        refetchOnWindowFocus: false, // Prevent excessive refetching
        refetchOnMount: false, // Only fetch if data is stale
        retry: 1,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem={false}
        storageKey="pwa-handel-theme"
      >
        <AuthProvider>
          <UserPermissionsProvider>
            <SessionRecordingProvider>
              <OrgThemeSync>
                {children}
              </OrgThemeSync>
              <Toaster position="top-center" richColors />
            </SessionRecordingProvider>
          </UserPermissionsProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
